import React from 'react';
import {Field, Formik} from "formik";
import TextField from "../../../components/Ui/TextField";
import BootstrapLoadingButton from "../../../components/Ui/BootstrapLoadingButton";
import {FIND_FICHE_BY_CODE} from "../../../api/Api";
import axios from 'axios';
import {Link, useHistory} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";


const useStyles = makeStyles(theme => ({
        root: {
            [theme.breakpoints.up('md')]: {
                '& .home-second-bg:hover': {
                    flex: '0 0 65%',
                    maxWidth: '65%'
                },
                '& .home-first-bg:hover': {
                    flex: ' 0 0 65%',
                    maxWidth: '65%'
                }
            }
            ,
        },
        table: {
            minWidth: 700,
        }
        ,
    }))
;


export default function IndexPage(props) {

    const classes = useStyles();


    const [httpErrorResponse,setHttpErrorResponse] = React.useState();

    const history = useHistory();

    async function searchDemande(values,helpers){

        try {

            setHttpErrorResponse();

            const response = await axios.get(
                FIND_FICHE_BY_CODE,
                {params: {code: values.input}}
            );

            history.push(`/fiches/details/${response.data.code}`);


        } catch (e) {

            if(e.response)
                setHttpErrorResponse(e.response)

        } finally {
            helpers.setSubmitting(false);
        }

    }

    return (
        <div className={`${classes.root} h-100 w-100`}>

            <div className="row h-100">

                <div className={'position-absolute w-100 text-center mt-5 pt-5 no-pointer-event'} style={{zIndex: 100}}>

                    <img src="/images/logo_cie.jpg" width={'20%'} className={'top-0 left-0'} alt=""/>

                </div>

                <div className="col-12 col-md home-second-bg">

                    <img src="/images/computer.jpg" width={'50%'} className={'position-absolute top-0 left-0'} alt=""/>

                    <div className={'h-100 d-flex align-items-center justify-content-center foreground'}>


                        <Link to={'/fiches/search'} >
                            <button className={'btn btn-primary'}>
                                <span className={'h2 font-weight-light'}>Consulter le status d'une demande</span>
                            </button>
                        </Link>

                        {/*<div>*/}

                        {/*    <div className={'h1 text-white font-weight-light mb-5'}>*/}
                        {/*        Recherchez votre demande*/}
                        {/*    </div>*/}

                        {/*    <Formik*/}
                        {/*        onSubmit={searchDemande}*/}
                        {/*        initialValues={{*/}
                        {/*            input: ''*/}
                        {/*        }}*/}
                        {/*    >*/}

                        {/*        {*/}
                        {/*            (formikHelpers) => {*/}
                        {/*                return (*/}

                        {/*                    <div className={'row no-gutters'}>*/}

                        {/*                        <div className={'col'}>*/}

                        {/*                            <Field*/}
                        {/*                                name={'input'}*/}
                        {/*                                component={TextField}*/}
                        {/*                                noLabel={true}*/}
                        {/*                                onChange={(e)=>{*/}
                        {/*                                    formikHelpers.handleChange(e);*/}

                        {/*                                    if(httpErrorResponse)*/}
                        {/*                                        setHttpErrorResponse();*/}

                        {/*                                }}*/}
                        {/*                            />*/}

                        {/*                        </div>*/}

                        {/*                        <div className={'col-auto d-flex ml-3'}>*/}
                        {/*                            <BootstrapLoadingButton loading={formikHelpers.isSubmitting} onClick={formikHelpers.submitForm} className={'btn btn-secondary px-4'}>*/}
                        {/*                                <span className={'flaticon-search'}></span>*/}
                        {/*                            </BootstrapLoadingButton>*/}
                        {/*                        </div>*/}

                        {/*                    </div>*/}

                        {/*                )*/}
                        {/*            }*/}
                        {/*        }*/}

                        {/*    </Formik>*/}

                        {/*    {*/}
                        {/*        httpErrorResponse && httpErrorResponse.status === 404 && (*/}
                        {/*            <div className={'small text-danger'}>*/}
                        {/*                Aucune trouvé avec ce code, veuillez réessayer*/}
                        {/*            </div>*/}
                        {/*        )*/}
                        {/*    }*/}

                        {/*</div>*/}

                    </div>

                </div>

                <div className="col-12 col-md home-first-bg">

                    <img src="/images/home-bg-1.jpg" width={'50%'} className={'position-absolute bottom-0 right-0'} alt=""/>


                    <div className={'h-100 d-flex align-items-center justify-content-center foreground'}>

                        <Link to={'/fiches/create'} >
                            <button className={'btn btn-success'}>
                                <span className={'h2 font-weight-light'}>Effectuer une demande</span>
                            </button>
                        </Link>

                    </div>


                </div>

            </div>

        </div>
    );
}